module.exports = __webpack_public_path__ + "img/across front.a81dbfbf.png";